import type { WysiwygAction } from '../../adapter/wysiwyg-adapter.types';
import type { Placeholder } from '../placeholder';

export type WysiwygPlaceholderChangeAction = WysiwygAction<
  ActionType.PlaceholderChange,
  Placeholder
>;

export type WysiwygPlaceholderDeleteAction = WysiwygAction<
  ActionType.PlaceholderDelete,
  Placeholder
>;

export type WysiwygPlaceholderDropdownDeleteAction = WysiwygAction<
  ActionType.PlaceholderDropdownDelete,
  {}
>;

export type WysiwygPlaceholderInsertFromDropdownAction = WysiwygAction<
  ActionType.PlaceholderInsertFromDropdown,
  Placeholder
>;

export enum ActionType {
  PlaceholderChange = 'PlaceholderChange',
  PlaceholderDelete = 'PlaceholderDelete',
  PlaceholderInsertFromDropdown = 'PlaceholderInsertFromDropdown',
  PlaceholderDropdownDelete = 'PlaceholderDropdownDelete',
}

export type WysiwygPlaceholderAction =
  | WysiwygPlaceholderChangeAction
  | WysiwygPlaceholderDeleteAction
  | WysiwygPlaceholderDropdownDeleteAction
  | WysiwygPlaceholderInsertFromDropdownAction;
